import '../../../styles/components/CusipUse.scss';
import React from 'react';
import { CusipUseDisclaimer } from '../../../components/modals/dataModals';

const CusipUse = () => (
  <div className="jpmCusipUse">
    <h3>VISITOR and User Legal Terms</h3>
    <p><CusipUseDisclaimer /></p>
  </div>
);

export default CusipUse;
